"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const Button_1 = require("../../button/Button");
const Progress_1 = __importDefault(require("../Progress/Progress"));
const Spinner_1 = __importDefault(require("../../loading/Spinner"));
const util_1 = require("../../../util");
const WizardStepper = function (props) {
    const { width, steps, title, className, initStep, onStep } = props;
    const [step, setStep] = (0, react_1.useState)(initStep || 0);
    const [boxMessage, setBoxMessage] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const { message, render, action, buttonText, buttonTextBack } = steps[step];
    const last = steps.length === step + 1;
    return (react_1.default.createElement("div", { className: (0, util_1.cnx)('glx-default-text', 'row', className), style: { width } },
        react_1.default.createElement("div", { className: "item" },
            react_1.default.createElement("h2", null, title)),
        react_1.default.createElement(Progress_1.default, { cur: step, max: steps.length }),
        react_1.default.createElement("div", { className: "item" },
            react_1.default.createElement("h3", null,
                step + 1,
                " / ",
                steps.length)),
        message && !loading ? (react_1.default.createElement("div", { className: "item" },
            react_1.default.createElement("div", { className: "flex-row messageBox" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement(react_icons_1.IOInformationCircle, null),
                    " Info:"),
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("span", { className: "text" }, message))))) : null,
        boxMessage && !loading ? (react_1.default.createElement("div", { className: "item" },
            react_1.default.createElement("div", { className: "flex-row messageBox messageBox--big" },
                react_1.default.createElement("div", { className: "row" }, boxMessage)))) : null,
        render?.(),
        !loading ? (react_1.default.createElement("div", { className: "item" },
            buttonTextBack ? (react_1.default.createElement(Button_1.Button, { onClick: () => {
                    setLoading(true);
                    if (action) {
                        action?.().then((r) => {
                            if (step !== 0 && r) {
                                onStep?.(step - 1);
                                setStep((s) => s - 1);
                            }
                            setLoading(false);
                        });
                    }
                    else {
                        if (step !== 0) {
                            onStep?.(step - 1);
                            setStep((s) => s - 1);
                        }
                        setLoading(false);
                    }
                } }, buttonTextBack)) : null,
            react_1.default.createElement(Button_1.Button, { onClick: () => {
                    setLoading(true);
                    if (action) {
                        action?.().then((r) => {
                            if (!last && r) {
                                onStep?.(step + 1);
                                setStep((s) => s + 1);
                            }
                            setLoading(false);
                        });
                    }
                    else {
                        if (!last) {
                            onStep?.(step + 1);
                            setStep((s) => s + 1);
                        }
                        setLoading(false);
                    }
                } }, buttonText))) : null,
        loading ? react_1.default.createElement(Spinner_1.default, null) : null));
};
WizardStepper.defaultProps = {
    className: undefined,
    initStep: undefined,
    onStep: undefined,
    width: undefined,
};
exports.default = WizardStepper;
